import { TextField } from "@mui/material";

function GSName ({ pagename, setPagename, createEnabled }) {

    return (
        <TextField
            sx={{paddingBottom: '10px'}}
            id="pagename"
            label="Pagename"
            value={pagename}
            onChange={(e) => setPagename(e.target.value)}
            size="small"
            fullWidth
            disabled={!createEnabled}
            />                        

    )
}

export default GSName;